exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errorLabel {\n  color: red;\n  font-size: 12px;\n  margin-left: 10px; }\n\n.midWidth {\n  width: 47.5%; }\n\n.rowContainer {\n  margin-bottom: 25px; }\n\n.fileContainer {\n  border: dashed 1px gray;\n  border-radius: 5px;\n  font-size: 14px;\n  margin: 10px;\n  padding: 10px; }\n\n.fileSelected {\n  background-color: #c4e6ff; }\n\n.fileNotAllowed {\n  background-color: #cacaca;\n  color: #323232; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/comunicaciones/new-comunicacion-dialog/new-comunicacion-dialog.component.scss
// module id = ../../../../../src/app/components/comunicaciones/new-comunicacion-dialog/new-comunicacion-dialog.component.scss
// module chunks = 0